import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/Hero";
import HowItWorks from "../components/Howitworks";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <HowItWorks />
      <Footer />
    </>
  );
};

export default Home;
